// @flow
const icons = {
  plus: {
    path: "M4.16663 10H15.8333M10 4.16663V15.8333",
    viewBox: "0 0 20 20"
  },
  checkmark: {
    path: "M17.8889 8L10.4028 15L7 11.8182",
    viewBox: "0 0 24 24"
  },
  menu: {
    path: "M3 6H21M5 12H21M7 18H21",
    viewBox: "0 0 24 24",
    strokeWidth: 2
  },
  close: {
    path: "M18 6L6 18M6 6L18 18",
    viewBox: "0 0 24 24",
    strokeWidth: 2
  }
};

export default icons;
